import {
  IconNameEnum,
  useDisruptionStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreDisruptionComponent } from "@b2bportal/core-types";
import { Icon } from "@b2bportal/core-ui";
import type { DisruptionExerciseHeaderProps } from "./DisruptionExerciseHeader";
import defaultStyles from "./DisruptionExerciseHeader.module.scss";

export const DisruptionExerciseHeaderDesktop = (
  props: DisruptionExerciseHeaderProps
) => {
  const COMPONENT_KEY = CoreDisruptionComponent.DisruptionExerciseHeader;
  const styles = useDisruptionStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={cn("disruptionExerciseHeaderContainer")}>
      <div className={cn("backIcon")}>
        <Icon iconName={IconNameEnum.backIcon} onClick={props.onBack} />
      </div>
      <span className={cn("title")}>{props.title}</span>
      {props.subtitle && (
        <span className={cn("subtitle")}>{props.subtitle}</span>
      )}
    </div>
  );
};
